export const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=`;
export const twitterUrl = `https://twitter.com/intent/tweet?text=`;
export const linkedinUrl = `https://www.linkedin.com/shareArticle?mini=true&url=`;
